import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import FooterImg from '../../assets/FooterImg.png';

const Footer = () => {
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          background: 'linear-gradient(132.99deg, rgba(79, 70, 229, 0.5) 0%, rgba(38, 20, 111, 0.5) 100%)',
          color: "#fff",
          textAlign: "center",
          py: { xs: 6, md: 8 },
        }}
      >
        {/* Content */}
        <Container maxWidth="md">
          <Box>
            <img src={FooterImg} alt="Footer" style={{ width:50, height: "auto", marginBottom: 24 }} />
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                lineHeight: 1.3,
                fontSize: {
                  xs: "26px",
                  sm: "32px",
                  md: "40px",
                },
                mb: 2,
              }}
            >
              Ready to Transform Your <br />
              <Box component="span" sx={{ color: "#4a3fff" }}>
                Field Operations?
              </Box>
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                opacity: 0.9,
                mb: 4,
              }}
            >
              Stop restarting every season. Start building long-term farmer
              continuity
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#4a3fff",
                px: 4,
                py: 1.5,
                borderRadius: "10px",
                fontWeight: 600,
                textTransform: "none",
                fontSize: "14px",
                "&:hover": {
                  backgroundColor: "#3a2fd6",
                },
              }}
            >
              Book a Demo Today →
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Footer */}
      <Box sx={{ pb: 2, backgroundColor: '#4F46E5', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', color: '#fff', px: 2, alignItems: 'flex-end', gap: 1 }}>
        <Typography
          sx={{
            fontSize: { xs: "12px", md: "13px" },
            opacity: 0.8,
            pt: 3,
          }}
        >
          © 2026 Farmer360. All rights reserved.
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "11px", md: "12px" },
            opacity: 0.7,
            pb: 1,
          }}
        >
          Product by ClearBiz Software Solutions
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;